// Bentuk request pulse: kelompokin device id per tipe, dan tandain tipe yang ditolak izin.

// gps ditarik terpisah di Stage 1, 'power' gak punya endpoint pulse sendiri.
export const EXCLUDED_PULSE_TYPES = ['gps', 'power'];

export function groupDeviceIdsByType(assets, excludedTypes = EXCLUDED_PULSE_TYPES) {
  const byType = new Map();
  (assets || []).forEach((asset) => {
    (asset?.devices || []).forEach((device) => {
      const type = device?.devcType;
      if (!type || excludedTypes.includes(type)) return;
      if (!byType.has(type)) byType.set(type, []);
      byType.get(type).push(device.devcUniqueId);
    });
  });

  return Array.from(byType, ([type, ids]) => ({ type, ids: [...new Set(ids)] }))
    .filter((group) => group.ids.length > 0);
}

// null = ditolak izin (errorCode 412). [] cuma berarti gak ada data.
export function resolveDeniedSensorTypes(pulseByType, healthTypes) {
  return (healthTypes || []).filter((type) => pulseByType.has(type) && pulseByType.get(type) === null);
}
